import gregorian from './gregorian.js';

export default function calendarProvider() {
	return gregorian;
}
